import React from 'react';

function Colaboradores() {
  return (
    <>
      <h1>Colaboradores</h1>
      <h3>Conselho de Administração</h3>
      <div className="colaboradoresContainer">
        <div>
          <p>Sandro Marques Virote</p>
          <h4>Diretor Presidente</h4>
        </div>
        <div>
          <p>Sergio Augusto Santana da Rosa</p>
          <h4>Diretor Financeiro</h4>
        </div>
        <div>
          <p>Eugenio Leonardo Pires Santos</p>
          <h4>Diretor Administrativo</h4>
        </div>
      </div>
      <h3>Conselheiros</h3>
      <div className="colaboradoresContainer">
        <div>
          <p>Assunção da Silva Castilhos</p>
        </div>
        <div>
          <p>Marcelo Pereira da Silva</p>
        </div>
      </div>
      <h3>Conselho Fiscal</h3>
      <div className="colaboradoresContainer">
        <div>
          <p>Jose ozi da Silva Lopes</p>
        </div>
        <div>
          <p>Marcus Vinicius Costa Santos</p>
        </div>
        <div>
          <p>Diego Araújo Ataia</p>
        </div>
        <div>
          <p>Maicon Francisco de Almeida Rodrigues</p>
        </div>
        <div>
          <p>André Luís Soares Dias</p>
        </div>
      </div>
      <h3>Colaboradoras</h3>
      <div className="colaboradoresContainer">
        <div>
          <p>Jurema Jandira Machado Boeck</p>
        </div>
        <div>
          <p>Cremilda Maria Silveira</p>
        </div>
      </div>
    </>
  )
}

export default Colaboradores;